"use client";

import { useQuery } from "@tanstack/react-query";

import { propertyAuditService } from "@/services/property-audit.service";

export function usePropertyHistory(
  propertyId: string,
  filters?: Record<string, any>,
) {
  return useQuery({
    queryKey: ["property-history", propertyId, filters],
    queryFn: () => propertyAuditService.getHistory(propertyId, filters),
    enabled: !!propertyId,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
